import PropTypes from 'prop-types';

import { ICompany } from 'src/ts/interfaces';
import CompanyDetailsForm from '../CompanyDetailsForm';
import CompanyDetailsLoader from '../CompanyDetailsLoader';
import { StyledContainer } from './styles';

export type CompanyDetailsProps = {
  name?: string;
  company?: ICompany;
  avatarUrl?: string;
  isLoading?: boolean;
  onSave: (data: ICompany) => void;
  isSaving?: boolean;
  settingsLink?: string | null;
};

const CompanyDetails: React.FC<CompanyDetailsProps> = (props: CompanyDetailsProps) => {
  const { company, isLoading, isSaving, onSave, settingsLink } = props;

  if (isLoading) return <CompanyDetailsLoader />;

  return (
    <StyledContainer>
      <CompanyDetailsForm
        isSaving={isSaving}
        handleOnSubmit={onSave}
        company={company}
        settingsLink={settingsLink}
      />
    </StyledContainer>
  );
};

CompanyDetails.propTypes = {
  name: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  settingsLink: PropTypes.string
};

CompanyDetails.defaultProps = {
  name: 'edit',
  isLoading: true,
  onSave: () => {
    console.log('Saved');
  },
  isSaving: false
};

export default CompanyDetails;
